/* GiftInOne 2.14.18: explicit mobile layouts with optional handle-only dragging. */
(function () {
  'use strict';
  if (window.GIOToolsDrawer) return;
  window.GIOToolsDrawer = {bind:function (options) {
    options=options||{};
    var main=options.main, pop=options.pop, side=options.side, handle=options.handle;
    var disposed=false, failed=false, applyingState=false, listeners=[], observer=null, lifecycleObserver=null;
    var resizeFrame=0, dragFrame=0, sizeKey='', lifecycleKey='', drag=null, suppressedClick=null, clickTimer=0;
    var empty={sync:function(){},destroy:function(){}};
    if(!main || !pop || !side || !handle)return empty;
    var pointerEnabled=!!window.PointerEvent && typeof handle.setPointerCapture==='function';
    function on(el,type,fn,opts) {
      if(!el || !el.addEventListener)return;
      el.addEventListener(type,fn,opts);
      listeners.push(function(){el.removeEventListener(type,fn,opts);});
    }
    function mobile() { return window.matchMedia ? window.matchMedia('(max-width:760px)').matches : window.innerWidth<=760; }
    function inputMode() { return main.classList.contains('gio-mobile-input-active'); }
    function state() { var value=options.getState?options.getState():'balanced';return /^(collapsed|balanced|full)$/.test(value)?value:'balanced'; }
    function allowed() {
      return !disposed && mobile() && !inputMode() && main.classList.contains('tingle-modal--visible') && !handle.disabled &&
        !main.classList.contains('gio-editor-v2-is-busy') && main.getAttribute('aria-busy')!=='true' && !(options.isBusy && options.isBusy());
    }
    function pixels(value) { var number=parseFloat(value);return Number.isFinite(number)?number:0; }
    function verticalBox(style) { return pixels(style.paddingTop)+pixels(style.paddingBottom)+pixels(style.borderTopWidth)+pixels(style.borderBottomWidth); }
    function visibleChild(el) { var css=getComputedStyle(el);return !el.hidden && css.display!=='none' && css.position!=='absolute' && css.position!=='fixed'; }
    function outerHeight(el) { var css=getComputedStyle(el);return el.getBoundingClientRect().height+pixels(css.marginTop)+pixels(css.marginBottom); }
    function toggleClass(name,value) { if(main.classList.contains(name)!==!!value)main.classList.toggle(name,!!value); }
    function clearGeometry() {
      // Display enhancements never change review, save, cart, or order data.
      // The bounded CSS layouts remain usable if measurement is unavailable.
      try { pop.style.removeProperty('--gio-drawer-height');pop.style.removeProperty('--gio-stage-min-height'); } catch(error) {}
      try { main.classList.remove('gio-tools-preview-hidden','gio-tools-resizing'); } catch(error) {}
    }
    function clearClickSuppression() {
      suppressedClick=null;
      try { if(clickTimer)window.clearTimeout(clickTimer); } catch(error) {}
      clickTimer=0;
    }
    function suppressDragClick(old) {
      if(!old || !old.moved)return;
      clearClickSuppression();
      suppressedClick={id:old.id,type:old.type};
      // The next physical pointerdown or any keydown clears this immediately.
      // The timer only retires a record when no synthetic click was emitted.
      try { clickTimer=window.setTimeout(clearClickSuppression,500); } catch(error) {}
    }
    function stopDragMonitor() { try{if(dragFrame)cancelAnimationFrame(dragFrame);}catch(error){}dragFrame=0; }
    function detachDrag() {
      var old=drag;drag=null;stopDragMonitor();
      try { main.classList.remove('gio-tools-resizing'); } catch(error) {}
      if(old) {
        try {
          if(typeof handle.releasePointerCapture==='function' && (!handle.hasPointerCapture || handle.hasPointerCapture(old.id)))handle.releasePointerCapture(old.id);
        } catch(error) {}
      }
      return old;
    }
    function applyState(next) {
      if(!options.setState)return false;
      applyingState=true;
      try { options.setState(next,false); }
      finally { applyingState=false; }
      return state()===next;
    }
    function notifyUser(next,source) {
      // Preference bookkeeping is optional and cannot break the controls.
      try { if(typeof options.onUserResize==='function')options.onUserResize(next,source); } catch(error) {}
    }
    function fallback() {
      failed=true;
      var old=detachDrag();suppressDragClick(old);
      if(old)try{applyState(old.state);}catch(error){}
      clearGeometry();
    }
    // Measure surrounding controls, not the current canvas, so shrinking the
    // preview cannot feed its own result into the next layout calculation.
    function stageChrome() {
      var stage=pop.querySelector('.gio-editor-v2-stage');
      if(!stage)return 0;
      var child=stage.querySelector('.gio-design-canvas-wrap,.gio-template-canvas-wrap'), total=0;
      if(!child)return verticalBox(getComputedStyle(stage));
      total=verticalBox(getComputedStyle(child));
      while(child && child!==stage) {
        var parent=child.parentElement;if(!parent)break;
        var css=getComputedStyle(parent), count=0;
        total+=verticalBox(css)+pixels(getComputedStyle(child).marginTop)+pixels(getComputedStyle(child).marginBottom);
        Array.prototype.forEach.call(parent.children,function(sibling){
          if(!visibleChild(sibling))return;
          count++;if(sibling!==child)total+=outerHeight(sibling);
        });
        if(/^(flex|grid)$/.test(css.display))total+=Math.max(0,count-1)*pixels(css.rowGap);
        child=parent;
      }
      return total;
    }
    function bounds() {
      var css=getComputedStyle(pop), height=Math.max(0,pop.clientHeight-pixels(css.paddingTop)-pixels(css.paddingBottom)-pixels(css.rowGap));
      var bar=side.querySelector('.gio-editor-v2-drawer-bar');
      // New navigation owns both tabs and the expand button. Count it once;
      // the tabs fallback keeps this helper compatible with the older shell.
      var navigation=side.querySelector('.gio-editor-v2-tools-navigation') || side.querySelector('.gio-editor-v2-tabs');
      var low=Math.min(height,Math.ceil((bar&&visibleChild(bar)?outerHeight(bar):0)+(navigation&&visibleChild(navigation)?outerHeight(navigation):0)+verticalBox(getComputedStyle(side))));
      var hidePreview=height<280;
      var thumbnail=hidePreview?0:Math.min(120,Math.max(80,height*.18));
      var preview=hidePreview?0:Math.min(Math.max(0,height-low-120),stageChrome()+thumbnail);
      var full=Math.max(low,height-preview);
      var desired=low+Math.min(240,Math.max(180,height*.36));
      var balanced=hidePreview?full:Math.max(low,Math.min(full,desired));
      return {height:height,collapsed:low,balanced:balanced,full:full,hidePreview:hidePreview};
    }
    function put(height,b,displayState) {
      if(!Number.isFinite(height) || !Number.isFinite(b.height))throw new Error('Invalid tool layout');
      pop.style.setProperty('--gio-stage-min-height','0px');
      pop.style.setProperty('--gio-drawer-height',Math.max(b.collapsed,Math.min(b.full,height)).toFixed(2)+'px');
      toggleClass('gio-tools-preview-hidden',b.hidePreview&&displayState!=='collapsed');
    }
    function sync() {
      if(disposed)return;
      try {
        var current=state();
        handle.setAttribute('aria-expanded',String(current!=='collapsed'));
        var label=current==='full'?'Tap to expand preview':'Tap to expand tools';
        if(pointerEnabled&&!failed)label+='; or drag up and down';
        handle.setAttribute('aria-label',label);
        handle.setAttribute('title',label);
        if(drag) {
          if(!allowed()){finishDrag(false);return;}
          if(!applyingState&&current!==drag.displayState) {
            // A separate expand button may have committed a newer explicit
            // preset. Retire the old gesture without overwriting that choice.
            var retired=detachDrag();suppressDragClick(retired);sync();
          }
          return;
        }
        if(failed || !mobile() || inputMode() || !main.classList.contains('tingle-modal--visible')){clearGeometry();return;}
        if(!pop.clientHeight)return;
        var b=bounds();put(b[current],b,current);
      } catch(error) { fallback(); }
    }
    function nearest(height,b,previous) {
      var next=previous, distance=Math.abs(height-b[previous]);
      ['collapsed','balanced','full'].forEach(function(candidate){
        var difference=Math.abs(height-b[candidate]);
        if(difference<distance-.01){next=candidate;distance=difference;}
      });
      return next;
    }
    function finishDrag(commit) {
      if(!drag)return;
      var old=detachDrag();
      suppressDragClick(old);
      try {
        if(commit&&old.moved&&allowed()&&!failed) {
          var next=nearest(old.currentHeight,bounds(),old.state);
          var changed=applyState(next);sync();
          if(changed)notifyUser(next,'drag');
        } else {
          // Cancelled gestures restore the stable preset. Do not record a
          // preference for a host cancellation, busy state, close or resize.
          if(old.moved)applyState(old.state);
          sync();
        }
      } catch(error) {
        failed=true;
        try{applyState(old.state);}catch(restoreError){}
        clearGeometry();
      }
    }
    function change(next,source) {
      try {
        if(drag)finishDrag(false);
        if(!allowed())return;
        if(applyState(next)){sync();notifyUser(next,source);}
      } catch(error) { fallback(); }
    }
    function monitorDrag() {
      if(!drag || disposed)return;
      try {
        if(!allowed() || pop.clientWidth!==drag.width || pop.clientHeight!==drag.height){finishDrag(false);return;}
        if(typeof requestAnimationFrame==='function')dragFrame=requestAnimationFrame(function(){dragFrame=0;monitorDrag();});
      } catch(error) { fallback(); }
    }
    function resize(force) {
      if(disposed)return;
      if(force&&drag)finishDrag(false);
      if(resizeFrame)return;
      try {
        resizeFrame=requestAnimationFrame(function(){
          resizeFrame=0;
          try {
            var key=pop.clientWidth+':'+pop.clientHeight+':'+mobile()+':'+inputMode();
            if(key===sizeKey)return;sizeKey=key;
            if(drag&&(pop.clientWidth!==drag.width || pop.clientHeight!==drag.height || !allowed()))finishDrag(false);
            sync();
          } catch(error) { fallback(); }
        });
      } catch(error) { if(drag)finishDrag(false);sync(); }
    }
    function lifecycle() {
      if(disposed)return;
      try {
        var key=String(main.classList.contains('tingle-modal--visible'))+':'+inputMode()+':'+String(main.classList.contains('gio-editor-v2-is-busy'))+':'+main.getAttribute('aria-busy');
        // Our own resizing/preview classes must not cancel an active gesture.
        if(drag&&!allowed())finishDrag(false);
        if(key!==lifecycleKey){lifecycleKey=key;if(!drag)sync();}
      } catch(error) { fallback(); }
    }
    // Explicit click/keyboard layouts are the baseline, even without Pointer
    // Events, pointer capture, observers, or successful geometry measurements.
    try {
      on(handle,'click',function(e){
        if(suppressedClick) {
          var keyboard=e.detail===0&&!e.pointerType;
          var otherPointer=e.pointerId!=null && e.pointerId!==suppressedClick.id;
          if(!keyboard&&!otherPointer) {
            clearClickSuppression();e.preventDefault();e.stopImmediatePropagation();return;
          }
          clearClickSuppression();
        }
        e.preventDefault();
        try { var current=state();change(current==='full'?'balanced':current==='collapsed'?'balanced':'full','click'); } catch(error) { fallback(); }
      });
      on(handle,'keydown',function(e){
        clearClickSuppression();
        if(!/^(ArrowUp|ArrowDown|Home|End)$/.test(e.key))return;
        e.preventDefault();
        try {
          var current=state();
          change(e.key==='Home'?'collapsed':e.key==='End'?'full':e.key==='ArrowUp'?(current==='collapsed'?'balanced':'full'):(current==='full'?'balanced':'collapsed'),'keyboard');
        } catch(error) { fallback(); }
      });
    } catch(error) { fallback(); }
    // Enhancement only: never attach dragging to the tabs, tool content, body,
    // or window. Host applications remain free to handle their native sheets.
    if(pointerEnabled)try {
      on(handle,'pointerdown',function(e){
        clearClickSuppression();
        try {
          if(drag || failed || !allowed() || e.button>0 || e.isPrimary===false)return;
          var current=state(), b=bounds(), actual=side.getBoundingClientRect().height;
          if(!Number.isFinite(actual))actual=b[current];
          handle.setPointerCapture(e.pointerId);
          drag={id:e.pointerId,type:e.pointerType||'',x:e.clientX,y:e.clientY,state:current,displayState:current,
            startHeight:Math.max(b.collapsed,Math.min(b.full,actual)),currentHeight:actual,width:pop.clientWidth,height:pop.clientHeight,moved:false};
          monitorDrag();
        } catch(error) { fallback(); }
      });
      on(handle,'pointermove',function(e){
        if(!drag || drag.id!==e.pointerId)return;
        try {
          if(!allowed()){finishDrag(false);return;}
          var delta=drag.y-e.clientY;
          if(!drag.moved&&Math.abs(delta)<=6)return;
          if(!drag.moved) {
            drag.moved=true;toggleClass('gio-tools-resizing',true);
            // Reveal controls when dragging up from the collapsed preset.
            // This temporary state is rolled back on cancellation.
            if(drag.state==='collapsed'){drag.displayState='balanced';applyState('balanced');}
          }
          var b=bounds(), value=Math.max(b.collapsed,Math.min(b.full,drag.startHeight+delta));
          drag.currentHeight=value;put(value,b,drag.displayState);
          if(e.cancelable!==false)e.preventDefault();
        } catch(error) { fallback(); }
      });
      on(handle,'pointerup',function(e){if(drag&&drag.id===e.pointerId)finishDrag(true);});
      on(handle,'pointercancel',function(e){if(drag&&drag.id===e.pointerId)finishDrag(false);});
      on(handle,'lostpointercapture',function(e){if(drag&&drag.id===e.pointerId)finishDrag(false);});
      on(window,'blur',function(){if(drag)finishDrag(false);});
    } catch(error) { fallback(); }
    try {
      if(window.ResizeObserver){observer=new ResizeObserver(function(){resize(false);});observer.observe(pop);}
      if(window.MutationObserver){lifecycleObserver=new MutationObserver(lifecycle);lifecycleObserver.observe(main,{attributes:true,attributeFilter:['class','aria-busy']});}
      on(window,'resize',function(){resize(true);},{passive:true});
      on(window,'orientationchange',function(){resize(true);},{passive:true});
    } catch(error) { fallback(); }
    sync();
    return {sync:sync,destroy:function(){
      if(disposed)return;
      if(drag)finishDrag(false);
      disposed=true;clearClickSuppression();stopDragMonitor();
      try { if(resizeFrame)cancelAnimationFrame(resizeFrame);if(observer)observer.disconnect();if(lifecycleObserver)lifecycleObserver.disconnect(); } catch(error) {}
      resizeFrame=0;
      listeners.forEach(function(remove){try{remove();}catch(error){}});listeners=[];
      clearGeometry();
    }};
  }};
}());
